import { combineEpics } from "redux-observable";

import uploadScoreCardEpic$ from "./uploadScoreCardEpic";
import uploadCsvClientsEpic$ from "./uploadCsvClientsEpic";
import runDbClientsScoringEpic$ from "./runDbClientsScoringEpic";
import getLastScoringLogsEpic$ from "./getLastScoringLogsEpic";
import getLastScoreCardEpic$ from "./getLastScoreCardEpic";
import getAllScoreCardRiskFactorsByTypeEpic$ from "./getAllScoreCardRiskFactorsByType";
import scoreCardCalculateEpic$ from "./scoreCardCalculateEpic";
import getOfferIdsEpic$ from "./getOfferIdsEpic";

export default combineEpics(
  uploadScoreCardEpic$,
  uploadCsvClientsEpic$,
  runDbClientsScoringEpic$,
  getLastScoringLogsEpic$,
  getLastScoreCardEpic$,
  getAllScoreCardRiskFactorsByTypeEpic$,
  scoreCardCalculateEpic$,
  getOfferIdsEpic$
);



// WEBPACK FOOTER //
// ./src/features/score-card/epics/index.js